import { Component, Input, OnChanges, OnInit } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { AppdataService } from 'src/app/services/app-data/appdata.service';
import { $b } from '../../../libs/browser_utils.js';

@Component({
  selector: 'app-livechat-status',
  templateUrl: './livechat-status.component.html',
  styleUrls: ['./livechat-status.component.scss']
})
export class LivechatStatusComponent implements OnInit, OnChanges {
  appConfig: any;
  encryptKey = 'ThisIsTheSecret';
  livechatStatus: any;
  @Input() data;
  @Input() sessionId;
  constructor(private appDataService: AppdataService) {}

  ngOnInit(): void {
    this.appConfig = this.appDataService.getConfig();
    // this.livechatStatus = this.appConfig.CommunicationInterface.activeLiveChat;

  }

  ngOnChanges() {
    this.livechatStatus = this.data;

    if(this.appConfig) {
      this.livechatStatus = this.appConfig.CommunicationInterface.activeLiveChat + " " + this.data;
    }
  }

  decryptAppConfig() {
    const decryptData = CryptoJS.AES.decrypt($b.GetLocalStorage('appconfig'), this.encryptKey);
    const obj = JSON.parse(decryptData.toString(CryptoJS.enc.Utf8));
    this.appConfig = obj;
  }
}
